import { CartItemDto } from "@/types/dto/cart-item-dto";

export function formatCartItemsDisplay(cartItems: CartItemDto[]) {
  if (!cartItems || cartItems.length === 0) {
    return "";
  }

  const firstItemName = cartItems[0].name;
  const additionalItemCount = cartItems.length - 1;

  if (additionalItemCount === 0) {
    return firstItemName;
  }

  return `${firstItemName} 외 ${additionalItemCount}`;
}
